import { createAction } from '@reduxjs/toolkit';
import { GetPartnerHeaderFeaturesResponse } from 'features/header/api/types';

export const headerActions = {
  getPartnerHeaderFeaturesRequest: createAction(
    '[header]GET_HEADER_FEATURES_REQUEST'
  ),
  getPartnerHeaderFeaturesSuccess:
    createAction<GetPartnerHeaderFeaturesResponse>(
      '[header]GET_HEADER_FEATURES_SUCCESS'
    ),
  getPartnerHeaderFeaturesFailure: createAction<string[]>(
    '[header]GET_HEADER_FEATURES_FAILURE'
  ),
};
